export const APP_ICON_URL =
  "https://img.alicdn.com/bao/uploaded/i4/2829330402/O1CN015OjaOo1EqAMg8F2mD_!!4611686018427381730-2-item_pic.png"

export const DESKTOP_APP_URL = "https://www.kadabao.com"

export const PRODUCT_TUTORIAL_URL =
  "https://meidengtech.feishu.cn/wiki/VhV3w03Dzi65MRkZ3bmc164zne1?from=from_copylink"

export const SERVICE_POLICY_URL =
  "https://meidengtech.feishu.cn/wiki/PbyrwSNE9iGAWvkcmFsceFHRnkc"

// 首页「加入微信群」弹层中的群二维码（纯二维码，卡片和取景框由样式绘制）
export const WECHAT_GROUP_QRCODE_URL =
  "https://cdn-testing.duobaogongxiao.com/kada-uploads/1793607311798-mzn2k8dq-dbde341b587852d7e007305842cb77840b08aa04.png"
